export default __webpack_public_path__ + "static/media/Twitter.9ffa1fe4.svg";